import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import {
	Box,
	Typography,
	Card,
	IconButton,
	Dialog,
	DialogTitle,
	DialogContent,
	CircularProgress,
} from "@mui/material";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Pagination from "@mui/material/Pagination";

import PeopleCard from "components/PeopleCard";
import RecentFileCard from "components/RecentFileCard";
import RecentMessageCard from "components/RecentMessageCard";

import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import { recentPeopleGroups } from "data/data";

const RecentItemsComponent = () => {
	const ITEMS = 3;
	const token = useSelector((state) => state.auth.token);
	const currentWorkspaces = useSelector(
		(state) => state.auth.user?.currentWorkspaces
	);
	const user = useSelector((state) => state.auth.user);

	const [isLoading, setIsLoading] = useState(false);
	const [filesList, setFilesList] = useState([]);
	const [messagesList, setMessagesList] = useState([]);
	const [peopleList, setPeopleList] = useState([]);
	const [recentValue, setRecentValue] = useState("all");
	const [currentIndex, setCurrentIndex] = useState(0);
	const [currentPage, setCurrentPage] = useState(1);
	const [currList, setCurrList] = useState([]);
	const [totalPages, setTotalPages] = useState(
		Math.ceil(currList?.length / ITEMS)
	);

	{
		/* FILES POPUP INFO */
	}
	const [documentInfo, setDocumentInfo] = useState(null);
	const [openDialog, setOpenDialog] = useState(false);
	const [noteId, setNoteId] = useState(null);

	const getNote = async (id) => {
		console.log("note id is", id);
		try {
			const url = new URL(
				`${process.env.REACT_APP_PORT}/notes/getNoteById/${id}`
			);
			const response = await fetch(url, {
				method: "GET",
				headers: { Authorization: `Bearer ${token}` },
			});

			const data = await response.json();
			setDocumentInfo(data);
		} catch (error) {
			console.log(error.message);
		}
	};

	const handleDialogClose = () => {
		setOpenDialog(false);
	};

	useEffect(() => {
		if (noteId) setDocumentInfo(getNote(noteId));
	}, [noteId]);

	const InfoDialog = () => {
		if (documentInfo && documentInfo.moteInfo && documentInfo.thirdPartyInfo)
			return (
				<Dialog open={openDialog} onClose={handleDialogClose}>
					<DialogTitle>
						<Box
							display="flex"
							justifyContent="space-between"
							alignItems="center"
						>
							<Typography variant="h4" fontWeight="bold">
								{documentInfo?.moteInfo?.name}
							</Typography>
						</Box>
					</DialogTitle>

					<DialogContent>
						<Box sx={{ whiteSpace: "pre-wrap", overflowY: "auto" }}>
							<Typography variant="body1">
								{documentInfo?.thirdPartyInfo}
							</Typography>
						</Box>
					</DialogContent>
				</Dialog>
			);
	};

	{
		/* MAIN COMPONENT CONTENT */
	}
	const handleChange = (event, newValue) => {
		setIsLoading(true);
		setRecentValue(newValue);
		setCurrentIndex(0); // Reset current index
		setCurrentPage(1); // Reset current page
		setTotalPages(0);
		setCurrList([]);

		switch (newValue) {
			case "all":
				setCurrList([...filesList, ...messagesList, ...peopleList]);
				setTotalPages(
					Math.ceil(
						[...filesList, ...messagesList, ...peopleList].length / ITEMS
					)
				);
				break;
			case "files":
				setCurrList(filesList);
				setTotalPages(Math.ceil(filesList.length / ITEMS));
				break;
			case "messages":
				setCurrList(messagesList);
				setTotalPages(Math.ceil(messagesList.length / ITEMS));
				break;
			case "people":
				setCurrList(peopleList);
				setTotalPages(Math.ceil(peopleList.length / ITEMS));
				break;
		}

		setIsLoading(false);
	};

	useEffect(() => {
		setCurrList([]);
		setFilesList([]);
		setMessagesList([]);
		setPeopleList([]);

		const getRecents = async () => {
			try {
				setIsLoading(true);

				{
					/* GET UPLOADED FILES */
				}
				const filesUrl = new URL(
					`${process.env.REACT_APP_PORT}/notes/getNotes`
				);
				const filesResponse = await fetch(filesUrl, {
					method: "GET",
					headers: { Authorization: `Bearer ${token}` },
				});
				let filesData = await filesResponse.json();
				filesData.notes = filesData?.notes?.map((file) => {
					return { ...file, kind: "file" };
				});
				if (filesResponse.status === 200) {
					setFilesList(filesData.notes);
				}

				{
					/* GET RECENT PEOPLE */
				}
				const peopleUrl = new URL(
					`${process.env.REACT_APP_PORT}/people/getPeople`
				);
				const peopleResponse = await fetch(peopleUrl, {
					method: "GET",
					headers: { Authorization: `Bearer ${token}` },
				});

                let peopleData = await peopleResponse.json();
                peopleData.people = peopleData?.people?.map((person) => { return { ...person, kind: "people" } }).reverse().splice(0,10);
                if (peopleResponse.status === 200) { setPeopleList(peopleData.people); }
                console.log("people data is", peopleData.people);

				{
					/* GET MESSAGES --> EMAILS */
				}
				const emailAddresses = peopleData?.people?.map(
					(person) => person.emailAddresses?.[0].value
				);
				const messagesUrl = new URL(
					`${process.env.REACT_APP_PORT}/people/getUserEmails`
				);
				const messagesResponse = await fetch(messagesUrl, {
					method: "POST",
					headers: {
						Authorization: `Bearer ${token}`,
						"Content-Type": "application/json",
					},
					body: JSON.stringify({ emailAddresses }),
				});

                let messagesData = await messagesResponse.json();
                messagesData.emails = messagesData?.emails?.map((message) => { return { ...message, kind: "message" }}).splice(0,10);
                if (messagesResponse.status === 200) { setMessagesList(messagesData.emails); }
                console.log("messages data is", messagesData.emails);

				{
					/* SET BASED ON CURRENT TAB VALUE */
				}
				switch (recentValue) {
					case "all":
						setCurrList([
							...filesData?.notes,
							...messagesData?.emails,
							...peopleData?.people,
						]);
						setTotalPages(
							Math.ceil(
								[
									...filesData?.notes,
									...messagesData?.emails,
									...peopleData?.people,
								].length / ITEMS
							)
						);
						break;
					case "files":
						setCurrList(filesData.notes);
						setTotalPages(Math.ceil(filesData?.notes?.length / ITEMS));
						break;
					case "message":
						setCurrList(messagesData.emails);
						setTotalPages(Math.ceil(messagesData?.emails?.length / ITEMS));
						break;
					case "people":
						setCurrList(peopleData.people);
						setTotalPages(Math.ceil(peopleData?.people?.length / ITEMS));
						break;
				}

				setIsLoading(false);
				setRecentValue("all");
			} catch (error) {
				setIsLoading(false);
				console.log(error);
			}
		};
		getRecents();

		console.log("currlist", currList);
	}, [currentWorkspaces]);

	return (
		<Card
			raised
			sx={{
				height: "500px",
				height: "100%",
				width: "100%",
				background: "white",
				borderRadius: "35px",
				padding: "5px",
				marginTop: "15px",
			}}
		>
			{/* TITLE */}
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					marginBottom: "10px",
				}}
			>
				<Typography
					variant="h3"
					sx={{
						paddingLeft: "15px",
						paddingRight: "50px",
						color: "#3B57B8",
						fontWeight: "bold",
					}}
				>
					Recent
				</Typography>
				<Tabs value={recentValue} onChange={handleChange}>
					<Tab
						value="all"
						label="All"
						sx={{ textTransform: "none", fontSize: "15px" }}
					/>
					<Tab
						value="files"
						label="Files"
						sx={{ textTransform: "none", fontSize: "15px" }}
					/>
					<Tab
						value="messages"
						label="Messages"
						sx={{ textTransform: "none", fontSize: "15px" }}
					/>
					{/* <Tab value="meetings" label="Meetings" sx={{ textTransform: 'none', fontSize: '12px' }} /> */}
					<Tab
						value="people"
						label="People"
						sx={{ textTransform: "none", fontSize: "15px" }}
					/>
				</Tabs>
			</Box>

			{/* RECENT CONTENT */}
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
					p: "2rem",
				}}
			>
				<IconButton
					disabled={currentIndex === 0 || currentPage === 1}
					onClick={() => {
						setCurrentIndex(currentIndex - 1);
						setCurrentPage(currentPage - 1);
					}}
				>
					<KeyboardArrowLeftIcon />
				</IconButton>

                {!isLoading && currList.length > 0 && currList.slice(
                    (currentPage - 1) * ITEMS,
                    currentPage * ITEMS
                )?.map((entity) => {
                    console.log(entity)
                    switch (entity?.kind) {
                        case 'file':
                            return (
                                <Box key={entity?._id}>
                                    <RecentFileCard 
                                        id={entity?._id}
                                        workspace={entity?.workspaceId}
                                        user={user}
                                        name={entity?.name}
                                        dateCreated={entity?.createdTime}
                                        setOpenDialog={setOpenDialog}
                                        setNoteId={setNoteId}
                                    />
                                    <InfoDialog />
                                </Box>
                            );
                        case 'people':
                            return (
                                <Box key={entity?.resourceName}>
                                    <PeopleCard 
                                        resourceName={entity?.resourceName}
                                        username={entity?.emailAddresses?.[0]?.value || entity.names?.[0]?.displayName}
                                        image={entity?.photos?.[0]?.url}
                                    />
                                </Box>
                            );
                            break;
                        case 'message':
                            return (
                                <Box key={entity?.id}>
                                    <RecentMessageCard 
                                        id={entity?.id}
                                        type={entity?.type}
                                        user={user}
                                        name={entity?.title}
                                        dateCreated={entity?.date}
                                        link={entity?.htmlLink}
                                    />
                                </Box>
                            );
                        default:
                            break;
                }})}
                {!isLoading && currList.length === 0 && (
                    <Typography variant="h4" fontWeight="bold" color="#3B57B8">Nothing found in your recents!</Typography>
                )}
                {isLoading && <CircularProgress />}

				<IconButton
					disabled={
						currentIndex + ITEMS >= currList?.length ||
						currentPage === totalPages
					}
					onClick={() => {
						setCurrentIndex(currentIndex + 1);
						setCurrentPage(currentPage + 1);
					}}
				>
					<KeyboardArrowRightIcon />
				</IconButton>
			</Box>

			{/* PAGINATION */}
			<Box sx={{ display: "flex", justifyContent: "center" }}>
				<Pagination
					count={totalPages}
					color="primary"
					siblingCount={0}
					page={currentPage}
					onChange={(event, page) => setCurrentPage(page)}
				/>
			</Box>
		</Card>
	);
};

export default RecentItemsComponent;
